import "./HomePage.css";
import React from "react";
import { ReactFlowProvider } from "reactflow";
import Counters from "../../components/0. DashBoard/Counters";
import Graficos from "../../components/0. DashBoard/Graficos";
import Comentarios from "../../components/0. DashBoard/Comentarios";
import Cumpleaños from "../../components/0. DashBoard/Cumpleaños";
import Calendario from "../../components/0. DashBoard/Calendario";
import Procesos from "../../components/0. DashBoard/Procesos";
import Equipo from "../../components/0. DashBoard/Equipo";
import Workflow from "../../components/0. DashBoard/Workflow";
import Whatsapp from "../../components/0. DashBoard/Whatsapp";
import Asistencia from "../../components/Asistencia/AsistenciaModal";

const HomePage = () => {
  return (
    <>
      <Equipo />
      <Asistencia />
      <div id="Home-Upper">
        <div id="Home-Left">
          <Counters />
          <div id="Home-Left-Lower">
            <Whatsapp />
            <ReactFlowProvider>
              <Workflow />
            </ReactFlowProvider>
          </div>
        </div>
        <div id="Home-Right">
          <Comentarios />
        </div>
      </div>
      <div id="Home-Lower">
        <Cumpleaños />
        <Calendario />
        <Procesos />
        <Graficos />
      </div>
    </>
  );
};

export default HomePage;
